import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const RedirectToNewGuidelines = () => <Navigate to="/guidelines" replace />;
const RedirectToNewCreateGuideline = () => <Navigate to="/create-guideline" replace />;
const RedirectToNewGuideline = () => {
  const { id } = useParams();
  return <Navigate to={`/guideline/${id}`} replace />;
};

export { RedirectToNewGuidelines, RedirectToNewCreateGuideline, RedirectToNewGuideline };
